import { render, staticRenderFns } from "./RiseupGoal.vue?vue&type=template&id=000a58a4&scoped=true&"
import script from "./RiseupGoal.vue?vue&type=script&lang=js&"
export * from "./RiseupGoal.vue?vue&type=script&lang=js&"
import style0 from "./RiseupGoal.vue?vue&type=style&index=0&id=000a58a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000a58a4",
  null
  
)

export default component.exports